// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"ProductAttributesList_tableContainer__cKoba","cardTitle":"ProductAttributesList_cardTitle__3Ug6q"};